import classNames from "classnames";
import { useId } from "react";
import { Controller, FieldValues, Path, useFormContext } from "react-hook-form";
import { denormalize, normalize } from "../../utils/document";
import Error from "../Error";
import Label from "./Label";

type props<t extends FieldValues> = {
  name: Path<t>;
  optional?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

function DocumentInput<t extends FieldValues>({
  name,
  optional,
  className,
  ...otherProps
}: props<t>) {
  const { control, formState } = useFormContext<t>();
  const error = formState.errors?.[name]?.message?.toString();
  const id = useId();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value, ref } }) => {
        let { type, number } = denormalize(value || "");

        return (
          <div className={classNames("", className)}>
            <Label htmlFor={id} optional={optional}>
              {type === "CI" ? "Cédula de identidad" : "Documento extranjero"}
            </Label>
            <input
              id={id}
              ref={ref}
              value={number}
              onChange={(e) => {
                onChange(normalize({ type, number: e.target.value }));
              }}
              className="text-gray-900 appearance-none block w-full bg-gray-100 border border-gray-100 rounded py-3 px-4 leading-tight focus:outline-hidden focus:bg-white focus:border-gray-500 dark:text-gray-900"
              {...otherProps}
            />
            <TypeSelector
              value={type}
              onChange={(newType) => {
                onChange(normalize({ type: newType, number: number }));
              }}
              disabled={otherProps.disabled}
            />
            {error && <Error>{error}</Error>}
          </div>
        );
      }}
    />
  );
}

export default DocumentInput;

const TypeSelector = ({
  value,
  onChange,
  disabled,
}: {
  value: "CI" | "OTHER";
  onChange: (value: "CI" | "OTHER") => void;
  disabled?: boolean;
}) => {
  return value === "CI" ? (
    <button
      className="text-xs underline"
      type="button"
      onClick={() => !disabled && onChange("OTHER")}
    >
      usar documento extranjero
    </button>
  ) : (
    <button
      className="text-xs underline"
      type="button"
      onClick={() => onChange("CI")}
    >
      usar cédula de identidad
    </button>
  );
};
